import { render } from "./CampoCep.vue?vue&type=template&id=fd098b64&ts=true"
import script from "./CampoCep.vue?vue&type=script&lang=ts"
export * from "./CampoCep.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__